import * as React from 'react';

function SvgSpringPlus6(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.707 22.681V25.937L3.607 30.264l20.102 5.085-20.102 5.085 20.102 5.085-20.102 5.085 20.103 5.085-20.103 5.087 20.102 5.085-20.102 5.085L23.71 76.03 3.606 81.115 23.708 86.2l-3 .76v6.822h5V90.526l17.1-4.326-20.106-5.085 20.105-5.085-20.105-5.085 20.105-5.085-20.102-5.085 20.102-5.085-20.103-5.087 20.103-5.085-20.102-5.085 20.102-5.085-20.103-5.085 3.003-.76v-6.822h-5z"
        fill={props.springcolor}
      />
      <path
        d="M23.207 140.297v6.092l-10.052 5.719 20.104 11.438-20.104 11.438 20.104 11.438-20.104 11.438 20.104 11.438-20.104 11.437 20.104 11.438-20.104 11.438 20.104 11.438-20.104 11.438 20.104 11.438-10.052 5.719v6.092"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path d="M34.74 0h-23v23h23V0zM34.74 292h-23v23h23v-23z" fill="#5BAD92" />
    </svg>
  );
}

export default SvgSpringPlus6;
